// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 1.79834L10 4.46501V10.8197L22 8.81973V22.0002H17V18.0002H13V22.0002H2V4.46501L6 1.79834Z"}}]};

const Museum2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'museum-2-filled',
    ref,
    icon: element,
  },
));

Museum2FilledIcon.displayName = 'Museum2FilledIcon';

export default Museum2FilledIcon;
